// Vendor libraries
import { ElementRef, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { finalize, takeWhile } from 'rxjs/operators';
import Sortable from 'sortablejs';
// Utils / constants
import equal from 'NewAngular/utils/equal/deep-equal';
import { COMPANY, FUND, INDEX, SECURITYLIST_GROUP_MULTI } from 'NewAngular/constants/core.constants';
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
// NgRx actions / selectors
import { addScatterPlotSecurities, removeScatterPlotSecurity, setScatterPlotSecurities, toggleScatterPlotSecurity, updateScatterPlotSecurityOrdering, } from 'ChartApp/ts/apps/scatter-plot/state/securities/securities.actions';
import { addSecuritiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.actions';
import { getChartOptions, getPlotOptions, loadingSecurities, partitionSecuritiesAndLists, } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { setAxisExtremes } from 'ChartApp/ts/apps/scatter-plot/state/axis-extremes/axis-extremes.action';
import { ScatterPlotSeriesType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import { YChartsScatterPlotService } from 'ChartApp/ts/services/ycharts-scatter-plot-service/ycharts-scatter-plot.service';
// Utils / Constants
import { getPlotOptionId } from 'ChartApp/ts/apps/scatter-plot/utils';
// Components
import { AddButtonAutocompleteComponent } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.component';
import { ScatterPlotCustomizeModalComponent } from 'ChartApp/ts/features/scatter-plot-page-shared/components/scatter-plot-customize-modal/scatter-plot-customize-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../../search/static/search/ts/features/multi-item-autocomplete/components/multi-item-autocomplete.component";
import * as i9 from "../../../../../../../../security_lists/static/security_lists/ts/features/security-list-selector-modals/multi-security-list-selector-modal/multi-security-list-selector-modal.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/skeleton-loaders-list/skeleton-loaders-list.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i12 from "../scatter-plot-customize-modal/scatter-plot-customize-modal.component";
const _c0 = ["sortableSecuritiesContainer"];
function ScatterPlotSecuritiesListComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ScatterPlotSecuritiesListComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-skeleton-loaders-list", 20);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("border", false)("loading", ctx_r3.loadingSecurities || ctx_r3.hasSecurityLists && !ctx_r3.securityListLabels)("numOfSkeletonLoaders", ctx_r3.securities.length);
} }
function ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div", 25)(3, "label", 26)(4, "input", 27);
    i0.ɵɵlistener("click", function ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_div_1_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r5); const security_r6 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.toggleScatterPlotSecurity(security_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 28)(6, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 30)(8, "div", 31)(9, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 32)(12, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(13, "svg", 33);
    i0.ɵɵlistener("click", function ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_div_1_Template_svg_click_13_listener() { i0.ɵɵrestoreView(_r5); const security_r6 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); const customizeModal_r7 = i0.ɵɵreference(25); return i0.ɵɵresetView(customizeModal_r7.openModal(ctx_r3.getPlotOptionId(security_r6), ctx_r3.getSecurityName(security_r6), ctx_r3.securitiesIncludedIndexMap[security_r6.id])); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(14, "div", 34);
    i0.ɵɵlistener("click", function ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_div_1_Template_div_click_14_listener() { i0.ɵɵrestoreView(_r5); const security_r6 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.removeScatterPlotSecurity(security_r6)); });
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(16, "svg", 15);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const security_r6 = ctx_r7.$implicit;
    const idx_r9 = ctx_r7.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(security_r6.id));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", security_r6.include);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r3.formattedSecurityNames[idx_r9]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Reorder");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-reorder-up");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Customize");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-gear");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Remove");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
function ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_div_1_Template, 17, 10, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const security_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !security_r6.parent_security_list);
} }
function ScatterPlotSecuritiesListComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ScatterPlotSecuritiesListComponent_ng_template_20_ng_container_0_Template, 2, 1, "ng-container", 21);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r3.securities)("ngForTrackBy", ctx_r3.trackById);
} }
/**
 *
 * Scatter Plot Securities List Component
 *
 * This component allows users to select securities.
 * It is in the left sidebar on the scatter plot page.
 *
 */
export class ScatterPlotSecuritiesListComponent {
    constructor(featureService, ngZone, securitiesService, securityListMenuService, store) {
        this.featureService = featureService;
        this.ngZone = ngZone;
        this.securitiesService = securitiesService;
        this.securityListMenuService = securityListMenuService;
        this.store = store;
        this.SECURITY_GROUP_TAB_OPTIONS = [SECURITYLIST_GROUP_MULTI, COMPANY, FUND, INDEX];
        this.fetchingSecuritesInfo = false;
        this.hasSecurityLists = true;
        this.loadingSecurities = true;
        this.formattedSecurityNames = [];
        this.securities = [];
        // A mapping of security ids to their position in the securities list, relative to other *included* securities.
        // Securities that are not included have a null value for their index.
        // Ex: securities = [{id: 'A', include: false}, {id: 'B', include: true}]. Here, security B is at index 0.
        // This is needed so the customize modal can use the correct default values.
        this.securitiesIncludedIndexMap = {};
        this.securitiesInfo = {};
        this.securityListLabels = null;
        this.isAlive = true;
        this.ychartsScatterPlotService = new YChartsScatterPlotService();
        this.mapStateToComponent = (state) => {
            this.chartOptions = getChartOptions(state);
            this.loadingSecurities = loadingSecurities(state);
            const { securityLists } = partitionSecuritiesAndLists(state);
            this.hasSecurityLists = securityLists.length > 0;
            this.securities = state.scatterPlot.securities;
            this.securitiesIncludedIndexMap = this.updateSecuritiesIncludedIndexMap();
            this.securitiesInfo = state.securitiesInfo;
            this.plotOptions = getPlotOptions(state);
            this.formattedSecurityNames = this.securities.map((sec) => this.getSecurityName(sec));
            if (this.securities.length > 0) {
                this.validateNextSecurities();
            }
        };
        this.getPlotOptionId = getPlotOptionId;
        this.storeSubscription = this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
        this.ychartsScatterPlotService.pointClick$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe((pointClickInfo) => {
            this.handlePointClick(pointClickInfo);
        });
    }
    ngOnInit() {
        this.securityListMenuService.getLabels().subscribe((response) => {
            this.securityListLabels = response;
            // Normally we format the security names in mapStateToComponent. Once we get the security
            // list labels we need to explicitly format the names.
            this.formattedSecurityNames = this.securities.map((sec) => this.getSecurityName(sec));
        });
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    /**
     * Reset the zoom when the user makes a change that might modify the axes.
     *
     * Note: This must be called **before** dispatching another action to update NgRx store.
     * The axisExtremes being updated is part of SCATTER_PLOT_PARAMS_NO_NEW_DATA, so changing its value will not
     * trigger a new backend request to be made. Another action must be dispatched after this one to trigger a request
     * that causes a new chart be drawn with the new axes.
     */
    resetZoom() {
        this.store.dispatch(setAxisExtremes({ axisExtremes: {} }));
    }
    removeScatterPlotSecurity(scatterPlotSecurity) {
        this.resetZoom();
        this.store.dispatch(removeScatterPlotSecurity({
            scatterPlotSecurity,
        }));
    }
    toggleScatterPlotSecurity(scatterPlotSecurity) {
        this.resetZoom();
        this.store.dispatch(toggleScatterPlotSecurity({
            scatterPlotSecurity,
        }));
    }
    trackById(index, security) {
        return security.id;
    }
    validateNextSecurities() {
        /**
         * Validates the next set of securities and security lists by doing the following:
         *   1. Remove duplicates
         *   2. If any securities are missing info, fetch their info
         *
         * One thing to keep in mind here is that it needs to preserve the order of securities and lists
         * that were passed in.
         */
        const uniqueSecurities = this.securities.filter((s, idx, arr) => idx === arr.findIndex((_) => _.id === s.id && _.type === s.type));
        const securitiesMissingInfo = uniqueSecurities
            .filter((s) => s.type === ScatterPlotSeriesType.security && !this.securitiesInfo[s.id])
            .map((sec) => sec.id);
        if (securitiesMissingInfo.length > 0 && !this.fetchingSecuritesInfo) {
            this.fetchingSecuritesInfo = true;
            this.securitiesService
                .getSecuritiesInfo(securitiesMissingInfo.join(','))
                .pipe(finalize(() => {
                const validSecurities = uniqueSecurities.filter((sec) => this.securitiesInfo[sec.id] || sec.type === 'security_list');
                // Set unique, valid securities regardless of whether the request succeeds
                if (!equal(this.securities, validSecurities)) {
                    this.store.dispatch(setScatterPlotSecurities({
                        scatterPlotSecurities: validSecurities,
                    }));
                }
                this.fetchingSecuritesInfo = false;
            }))
                .subscribe((data) => {
                this.store.dispatch(addSecuritiesInfo({ securitiesInfo: data }));
            });
        }
        else if (securitiesMissingInfo.length === 0) {
            if (!equal(this.securities, uniqueSecurities)) {
                this.store.dispatch(setScatterPlotSecurities({ scatterPlotSecurities: uniqueSecurities }));
            }
        }
    }
    addMultipleSecurities(securityIds) {
        this.focusAutocompleter();
        this.resetZoom();
        const uniqueSecurityIds = [...new Set(securityIds)];
        const securityIdsParam = uniqueSecurityIds.join(',');
        this.securitiesService.getSecuritiesInfo(securityIdsParam).subscribe((response) => {
            if (response.length > 0) {
                const securitiesInfo = response.map((info) => ({
                    id: info.security_id,
                    security_name: info.security_name,
                    feature_needed: info.feature_needed,
                    features_needed: info.features_needed,
                    display_security_id: info.display_security_id,
                    inception_date: info.inception_date,
                }));
                const scatterPlotSecurities = response.map((info) => ({
                    id: info.security_id,
                    include: true,
                    type: ScatterPlotSeriesType.security,
                }));
                this.store.dispatch(addSecuritiesInfo({ securitiesInfo }));
                this.store.dispatch(addScatterPlotSecurities({
                    scatterPlotSecurities,
                    scatterPlotChartOptions: this.chartOptions,
                }));
            }
        });
    }
    addSecurity(securityResult) {
        this.addMultipleSecurities([securityResult.search_id]);
    }
    addSecurityLists(response) {
        const formattedSecurityLists = response.securityLists.flatMap((list) => {
            // We could do a better job of filtering out security lists that are missing feature. Use this for now
            const hasAccessToFeature = this.featureService.userCanAccess(list.item);
            return hasAccessToFeature
                ? [
                    {
                        id: list.item.key,
                        include: true,
                        security_group: list.group,
                        type: ScatterPlotSeriesType.securityList,
                    },
                ]
                : [];
        });
        this.resetZoom();
        this.store.dispatch(addScatterPlotSecurities({
            scatterPlotSecurities: formattedSecurityLists,
            scatterPlotChartOptions: this.chartOptions,
        }));
    }
    getSecurityName(security) {
        if (security.type === ScatterPlotSeriesType.security) {
            const info = this.securitiesInfo[security.id];
            return info
                ? `${info.security_name} (${info.display_security_id ? info.display_security_id : security.id})`
                : '';
        }
        return this.securityListLabels ? this.securityListLabels[security.security_group][security.id] : '';
    }
    initializeSortable() {
        // For performance reasons we don't want Angular change detection to run while dragging an
        // element around, so we explicitly run SortableJS outside of Angular.
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.sortableSecuritiesContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (event) => {
                    // Once we're done updating we want to dispatch the NgRx action from inside ngZone again.
                    this.ngZone.run(() => {
                        this.store.dispatch(updateScatterPlotSecurityOrdering({ oldIndex: event.oldIndex, newIndex: event.newIndex }));
                        // This is a workaround for a bug in the Sortable library which can recheck
                        // unchecked items after dragging. There is no entrypoint provided by SortableJS
                        // after it updates the checkbox state, so we need to delay execution.
                        setTimeout(() => {
                            const { children } = event.target;
                            this.securities.forEach((security) => {
                                for (let i = 0; i < children.length; i += 1) {
                                    const child = children[i];
                                    if (security.id === child.id) {
                                        const el = child.getElementsByClassName('custom-control-input')[0];
                                        if (el.checked !== security.include) {
                                            el.checked = security.include;
                                        }
                                    }
                                }
                            });
                        });
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, 'options-list-item');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'options-list-item');
                },
            });
        });
    }
    /**
     * Update the index of securities relative to other included securities.
     * @return An object mapping security ids to their index relative to other included securities.
     */
    updateSecuritiesIncludedIndexMap() {
        let includedIndex = 0;
        for (let i = 0; i < this.securities.length; i += 1) {
            const security = this.securities[i];
            if (security.include) {
                this.securitiesIncludedIndexMap[security.id] = includedIndex;
                includedIndex += 1;
            }
            else {
                this.securitiesIncludedIndexMap[security.id] = -1;
            }
        }
        return this.securitiesIncludedIndexMap;
    }
    /**
     * When a point is clicked on the scatter plot, we want to open the customize modal for that specific point.
     * - For points that belong to a security, the behavior is identical to clicking the "Customize" Gear icon.
     * - For points that belong to a security list, we override the options for only the individual security
     *    that was clicked, not the entire list. We achieve this by adding a security to the state, as well as the
     *    customizations to the plotOptions. Unlike normal securities and lists, "security overrides" cannot have
     *    a default color.
     *
     * @param pointClickInfo: The relevant info about the point that was clicked, given by YChartsScatterPlotService.
     *                        See the PointClickInfo docstring for more details.
     */
    handlePointClick(pointClickInfo) {
        const { securityId, securityName, uniquePointId } = pointClickInfo;
        let { parentSecurityListId } = pointClickInfo;
        const plotOptionId = `${ScatterPlotSeriesType.security}__${securityId}`;
        let includedIndex;
        let newOverride = true;
        if (this.securities
            .filter((sec) => !sec.parent_security_list && sec.include)
            .map((sec) => sec.id)
            .includes(securityId)) {
            // The security is part of the left sidebar. Open the normal customize modal.
            includedIndex = this.securitiesIncludedIndexMap[securityId];
        }
        else {
            if (!parentSecurityListId) {
                newOverride = false;
                parentSecurityListId = this.securities.find((sec) => sec.id === securityId).parent_security_list;
            }
            // We are overriding a security's plot options.
            // Show the parent security list's plot options as a starting point.
            includedIndex = this.securitiesIncludedIndexMap[parentSecurityListId];
        }
        const parentSecurityListPlotOptionsId = parentSecurityListId
            ? `${ScatterPlotSeriesType.securityList}__${parentSecurityListId}`
            : '';
        this.customizeModal.openModal(plotOptionId, securityName, includedIndex, parentSecurityListPlotOptionsId, newOverride, uniquePointId);
    }
    focusAutocompleter() {
        if (this.autocompleteComponent) {
            this.autocompleteComponent.focus();
        }
    }
}
ScatterPlotSecuritiesListComponent.ɵfac = function ScatterPlotSecuritiesListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotSecuritiesListComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.SecuritiesService), i0.ɵɵdirectiveInject(i3.SecurityListMenuService), i0.ɵɵdirectiveInject(i4.Store)); };
ScatterPlotSecuritiesListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotSecuritiesListComponent, selectors: [["ycn-scatter-plot-securities-list"]], viewQuery: function ScatterPlotSecuritiesListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(AddButtonAutocompleteComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(ScatterPlotCustomizeModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableSecuritiesContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customizeModal = _t.first);
    } }, standalone: false, decls: 28, vars: 9, consts: [["sortableSecuritiesContainer", ""], ["skeletonLoadersList", ""], ["securitiesList", ""], ["helpModal", ""], ["customizeModal", ""], ["securityListModal", ""], [1, "panel-sidebar-section"], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title"], [1, "help-toggler", 3, "click"], [1, "panel-sidebar-section-row"], [1, "input-group", 3, "multiSubmitHandler", "submitHandler", "appendToBody", "searchType", "showMoreResultsUrl"], [1, "divider-vertical"], [1, "panel-sidebar-section-control"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "panel-sidebar-section-body"], [1, "options-list"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "submitHandler", "securityGroupTabOptions", "showSetOperations"], [3, "border", "loading", "numOfSkeletonLoaders"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "options-list-item", "data-test-id", "scatter-plot-security-item", 3, "id", 4, "ngIf"], ["data-test-id", "scatter-plot-security-item", 1, "options-list-item", 3, "id"], [1, "options-list-item-header"], [1, "options-list-item-title"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "options-list-item-controls"], ["data-test-id", "scatter-plot-security-reorder", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up", 3, "tooltipTitle"], ["data-test-id", "scatter-plot-security-customize", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-gear", 3, "tooltipTitle"], ["ycnIcon", "", 3, "click", "name"], ["data-test-id", "scatter-plot-security-remove", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click", "tooltipTitle"]], template: function ScatterPlotSecuritiesListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "section", 6)(1, "div", 7)(2, "div", 8);
        i0.ɵɵtext(3, " Securities & Lists ");
        i0.ɵɵelementStart(4, "span", 9);
        i0.ɵɵlistener("click", function ScatterPlotSecuritiesListComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(23); return i0.ɵɵresetView(helpModal_r2.openModal("scatter_plot_securities_and_lists")); });
        i0.ɵɵtext(5, "(?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 10)(7, "ycn-multi-item-autocomplete", 11);
        i0.ɵɵlistener("multiSubmitHandler", function ScatterPlotSecuritiesListComponent_Template_ycn_multi_item_autocomplete_multiSubmitHandler_7_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addMultipleSecurities($event)); })("submitHandler", function ScatterPlotSecuritiesListComponent_Template_ycn_multi_item_autocomplete_submitHandler_7_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addSecurity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "div", 12);
        i0.ɵɵelementStart(9, "div", 13)(10, "a", 14);
        i0.ɵɵlistener("click", function ScatterPlotSecuritiesListComponent_Template_a_click_10_listener() { i0.ɵɵrestoreView(_r1); const securityListModal_r3 = i0.ɵɵreference(27); return i0.ɵɵresetView(securityListModal_r3.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 15);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "List");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(14, "div", 16)(15, "div", 17, 0);
        i0.ɵɵtemplate(17, ScatterPlotSecuritiesListComponent_ng_container_17_Template, 1, 0, "ng-container", 18)(18, ScatterPlotSecuritiesListComponent_ng_template_18_Template, 1, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(20, ScatterPlotSecuritiesListComponent_ng_template_20_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(22, "ycn-help-modal", null, 3)(24, "ycn-scatter-plot-customize-modal", null, 4);
        i0.ɵɵelementStart(26, "ycn-multi-security-list-selector-modal", 19, 5);
        i0.ɵɵlistener("submitHandler", function ScatterPlotSecuritiesListComponent_Template_ycn_multi_security_list_selector_modal_submitHandler_26_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addSecurityLists($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const skeletonLoadersList_r10 = i0.ɵɵreference(19);
        const securitiesList_r11 = i0.ɵɵreference(21);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("appendToBody", true)("searchType", "scatter_plot_securities")("showMoreResultsUrl", false);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("name", "icon-list");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.loadingSecurities || ctx.hasSecurityLists && !ctx.securityListLabels)("ngIfThen", skeletonLoadersList_r10)("ngIfElse", securitiesList_r11);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("securityGroupTabOptions", ctx.SECURITY_GROUP_TAB_OPTIONS)("showSetOperations", false);
    } }, dependencies: [i5.NgForOf, i5.NgIf, i6.HelpModalComponent, i7.IconDirective, i8.MultiItemAutocompleteComponent, i9.MultiSecurityListSelectorModalComponent, i10.SkeletonLoadersListComponent, i11.TooltipDirective, i12.ScatterPlotCustomizeModalComponent], encapsulation: 2 });
